<template>
  <v-container fluid fill-height>
    <v-row class="text-center" justify="center">
      <v-col cols="auto">
        <h1 class="text-h2">404</h1>
        <div class="text-h3 my-10">لم نتمكن من العثور علي الصفحة !</div>
        <v-btn depressed to="/app"> عودة </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ErrorPage",
  metaInfo: { title: "404" },
};
</script>
